export default __webpack_public_path__ + "static/media/close-v2.1e2de53f.svg";